/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { CloseIcon, PetBirthdayFormCalendarIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GvDatePickerController } from "../../../components/Controllers";
import { usePetUpdate } from "../../../services/pet-update/pet-update.service";
import { usePetCareStore } from "../../../hooks/redux-hooks/pet-care-data/pet-care-data-store";
import { IGeneralPetCareItem } from "../../../services/Standard-of-care/standard-of-care.interface";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

const PetBirthdayFormModal = () => {
  const { openModal, closeModal, wellnessSelectedPetId } = useModal();
  const navigate = useNavigate();
  const { petBirthdayUpdate, petUpdated } = usePetUpdate();
  const { petList }= usePetStore();
  const [selectedPet, setPetSelected] = useState<IPetItemResponse | null | undefined>(null);


  const { control, handleSubmit, watch, formState: { isValid } } = useForm({
    mode: "onChange",
    defaultValues: {
      birthdate: null,
    },
  });

  const birthdateValue = watch("birthdate");

  const handleCloseModal = () => {
    closeModal();
  };

  const handleCtaClick = handleSubmit((data) => {
    if (selectedPet) {
      const formattedBirthdate = data.birthdate ?
        new Date(data.birthdate).toLocaleDateString("en-US") :
        null;
      const petData = {
        birthdate: data.birthdate,
      };

      userActivityLogger(MIXPANEL_EVENTS.USER_WP_PET_BIRTHDAY_INPUT,
        { pet_id: selectedPet.id,
          pet_name: selectedPet.name,
          dob: formattedBirthdate,
        });

      petBirthdayUpdate(selectedPet?.id, petData);
    }
  });

  useEffect(() => {
    if (petList && wellnessSelectedPetId) {
      let pet;

      if (wellnessSelectedPetId) {
        pet = petList.find((pet) => pet.id === wellnessSelectedPetId);
      }

      setPetSelected(pet);
    }
  }, [petList, wellnessSelectedPetId]);

  useEffect(() => {
    if (petUpdated && selectedPet) {
      closeModal();
      navigate(`${PAGES_PATH.WELLNESS_PLAN_DETAILS}?id=${selectedPet.id}`);
    }
  }, [petUpdated]);

  return (
    <div className="h-full flex flex-col justify-between px-3">
      <div className="w-full flex justify-end">
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="h-full flex flex-col gap-2 items-center
      min-h-0 overflow-y-auto !w-full px-2 my-6 scrollbar-thin">
        <div className="flex flex-col gap-3 mb-6">
          <div className="text-3xl font-semibold flex flex-col">
            <p>{`When is ${selectedPet?.name}'s`}</p>
            <p>birthday?</p>
          </div>
          <div className="text-sm">
            {"Enter your pet's birthday so we can tailor a TotalCare plan based on their age and life stage."}
          </div>
        </div>
        <div className="w-full flex flex-col">
          <GvDatePickerController
            control={control}
            name="birthdate"
            label="Date of Birth"
            disableFuture={true}
            minDate={new Date(631152000 * 1000)}
            maxDate={new Date()}
            customIcon={PetBirthdayFormCalendarIcon}
            labelStyle="text-xs font-semibold"
          />
          <div className="text-xs text-gray-1 mt-[-0.5rem]">
            {"If you're unsure, a rough estimate works!"}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 pb-1 pt-1.5 mt-2">
        <StyledBookingFlowButton
          color="primary"
          disabled={!birthdateValue || !selectedPet}
          size="small"
          className="w-full"
          onClick={handleCtaClick}
        >
          Continue
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default PetBirthdayFormModal;
